import chroma from 'chroma-js'

// vue choropleth
export const validNumber = (num) =>
  !(
    isNaN(num) ||
    num == null ||
    num == undefined ||
    // for our use case, we don't consider Infinity a valid number
    num == Infinity ||
    num == -Infinity
  )

export const getMin = (array, key) =>
  Math.min(
    ...array.filter((x) => validNumber(x[key])).map((x) => Number(x[key]))
  )

export const getMax = (array, key) =>
  Math.max(
    ...array.filter((x) => validNumber(x[key])).map((x) => Number(x[key]))
  )

export const normalizeValue = (value, min, max) => (value - min) / (max - min)

export const getColor = (param, colorScale, min, max) =>
  chroma.scale(colorScale).mode('lch')(normalizeValue(param, min, max)).hex()
// end vue choropleth

export const reportColor = (val1, val2) => {
  let calculate = (Number(val1) / Number(val2)) * 100

  return calculate > 75
    ? '#de7062'
    : calculate > 50
    ? '#e5936b'
    : calculate > 25
    ? '#e9ae7b'
    : '#e7d090'
}

export const getPercentage = (val1, val2) => {
  let calculate = (Number(val1) / Number(val2)) * 100
  return calculate.toFixed(1)
}

export const addDots = (param) => {
  param += ''
  var x = param.split('.')
  var x1 = x[0]
  var x2 = x.length > 1 ? '.' + x[1] : ''
  var rgx = /(\d+)(\d{3})/
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2')
  }
  return x1 + x2
}

export const today = () => {
  var today = new Date()
  var dd = String(today.getDate()).padStart(2, '0')
  var mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
  var yyyy = today.getFullYear()

  today = dd + '/' + mm + '/' + yyyy
  return today
}

export const yesterday = () => {
  var today = new Date()
  var yesterday = new Date(today)
  var dd = String(yesterday.getDate() - 1).padStart(2, '0')
  var mm = String(yesterday.getMonth() + 1).padStart(2, '0') //January is 0!
  var yyyy = yesterday.getFullYear()

  yesterday = dd + '/' + mm + '/' + yyyy
  return yesterday
}

export const getDotColor = (val) => {
  let result = (Number(val) / 10) * 100
  return result > 79 ? 'green' : result > 59 ? 'orange' : 'red'
}

export const get3MPercentage = (val1, val2) => {
  let denom = Number(val2) * 10
  let calculate = (Number(val1) / denom) * 100
  return calculate.toFixed(1)
}

export const formatDate = (val) => {
  let date = new Date(val)
  const result =
    (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
    '-' +
    (date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
    '-' +
    date.getFullYear()

  return result
}
